import "./PromoCodeModal.scss";
import closeIcon from "../../../images/CloseCircle.svg";

export default function ConfirmationModal({
  isOpen,
  onClose,
  title,
  message,
  cancelAction = {},
  confirmAction = {},
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const cancel = {
    label: "Cancel",
    className: "cancel-btn",
    onClick: onClose,
    ...cancelAction,
  };

  const confirm = {
    label: "Confirm",
    className: "primary-btn",
    onClick: () => {},
    ...confirmAction,
  };

  return (
    <div className="promo-code-modal-overlay" onClick={handleOverlayClick}>
      <div className={`promo-code-modal`}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>

        <div className="modal-body">
          <p>{message}</p>
        </div>

        <div className="modal-actions">
          <button className={cancel.className} onClick={cancel.onClick} disabled={cancel.disabled}>
            {cancel.label}
          </button>
          <button
            className={confirm.className}
            onClick={confirm.onClick}
            disabled={confirm.disabled}
          >
            {confirm.label}
          </button>
        </div>
      </div>
    </div>
  );
}
